import { Injectable } from '@angular/core';
import { catchError, merge, of, shareReplay, startWith, Subject, switchMap } from 'rxjs';
import { OiqNotificationEventsStore } from '../events/events.store';
import { OiqSmsAlertsService } from './sms-alerts.service';

@Injectable({
  providedIn: 'root',
})
export class OiqSmsAlertsStore {
  constructor(
    private service: OiqSmsAlertsService,
    private eventsStore: OiqNotificationEventsStore
  ) {}

  reload$ = new Subject<void>();

  /** Polled on the same interval as the calendar count, and refreshed after mark-read. */
  unreadCount$ = merge(this.eventsStore.interval$, this.reload$).pipe(
    switchMap(() => this.service.unreadCount()),
    shareReplay(1)
  );

  /** startWith: the SMS tab subscribes after the panel's initial reload$ has already fired. */
  alerts$ = this.reload$.pipe(
    startWith(undefined),
    switchMap(() => this.service.list().pipe(catchError(() => of([])))),
    shareReplay(1)
  );

  markRead(smsMessageIds: number[]): void {
    if (!smsMessageIds.length) {
      return;
    }
    this.service.markRead(smsMessageIds).subscribe({
      next: () => this.reload$.next(),
    });
  }
}
